<template>
  <v-select
    v-model="mapeamentoSelecionado"
    :items="mapeamentos"
    item-text="nome"
    item-value="id"
    label="Mapeamento:"
    return-object
  >
    <template v-slot:item="{ item }">
      <span>{{ item.nome }}</span>
      <v-chip
        v-if="item.mapeamentoImportado"
        class="ml-2"
        color="success"
        outlined
        x-small
      >
        Importado
      </v-chip>
    </template>
    <template v-slot:selection="{ item }">
      <span>{{ item.nome }}</span>
      <v-chip
        v-if="item.mapeamentoImportado"
        class="ml-2"
        color="success"
        outlined
        x-small
      >
        Importado
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'AppSelectMapeamento',

  props: {
    mapeamento: {
      type: Object,
      default: null,
    },
    mapeamentos: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      mapeamentoSelecionado: this.mapeamento,
    };
  },

  watch: {
    mapeamento(value) {
      this.mapeamentoSelecionado = value;
    },
    mapeamentoSelecionado() {
      return this.$emit('return', this.mapeamentoSelecionado);
    },
  },
};
</script>
